module.exports = __webpack_public_path__ + "img/logo5.108ab442.png";